import { createContext } from 'react';

const CourtContext = createContext({});

export default CourtContext;
